import RadioButtonGroup from '../../../Common/RadioButtonGroup/RadioButtonGroup';
import React from 'react';
import Dictionary from '../../../../types/report/Dictionary';
import { createDictionaryOption } from './DictionarySelector.Helpers';

interface Props {
    isWaiting: boolean;
    dictionaryNumber: number | null;
    dictionaries: Dictionary[];
    onDictionarySelected: (number: number) => void;
}

class DictionarySelector extends React.Component<Props, { scrollLeft: number }> {

    constructor(props: Props) {
        super(props);

        this.state = {
            scrollLeft: 0
        }

        this.onDictionarySelected = this.onDictionarySelected.bind(this);
    }

    onDictionarySelected(value: string, scrollLeft?: number): void {

        this.setState({ scrollLeft: scrollLeft || 0 }, () => {
            this.props.onDictionarySelected(parseInt(value));
        });
    }

    render(): JSX.Element {

        if (this.props.dictionaries.length === 0) {

            return (<></>);
        }

        return (
            <>
                <RadioButtonGroup
                    className='sticky min-height-44px padding-10px overflow-x-auto'
                    options={this.props.dictionaries.map(createDictionaryOption)}
                    value={(this.props.dictionaryNumber as number).toString()}
                    name="report-dictionaries"
                    onChange={this.onDictionarySelected}
                    scrollLeft={this.state.scrollLeft} />
            </>
        );
    }
}

export default DictionarySelector;
